import { useStore } from '@tanstack/react-store';

import { MobileChatsDrawerStore } from '@/features/stores/MobileChatsDrawerStore';

const useMobileChatsDrawer = () => {
  const isOpenMobileChatsDrawer = useStore(MobileChatsDrawerStore, (s) => s.open);

  const openMobileChatsDrawer = () => {
    MobileChatsDrawerStore.setState((s) => ({ open: true }));
  };

  const closeMobileChatsDrawer = () => {
    MobileChatsDrawerStore.setState((s) => ({ open: false }));
  };

  return { isOpenMobileChatsDrawer, closeMobileChatsDrawer, openMobileChatsDrawer };
};
export default useMobileChatsDrawer;
